import { Avatar, AvatarProps } from '@mui/material';

import { SvbrgChatMessageRole } from '@/generated/gql/graphql';
import { UserAvatar } from '~/components/UserAvatar/UserAvatar';
import { useUser } from '~/hooks/useUser/useUser';

export type ChatAvatarProps = {
  role: SvbrgChatMessageRole;
  createdBy?: string;
} & AvatarProps;

export const ChatAvatar = ({ role, createdBy, ...rest }: ChatAvatarProps) => {
  const { profile, loading } = useUser({ userId: createdBy });
  if (role === SvbrgChatMessageRole.USER) {
    return loading || !profile ? null : <UserAvatar user={profile} />;
  }
  return (
    <Avatar {...rest}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" rx="20" fill="#031021" />
        <g>
          <path
            d="M10.232 11.352c.626 0 1.141-.515 1.141-1.141 0-.626-.51-1.136-1.141-1.141-.627 0-1.141.51-1.141 1.141 0 .626.514 1.136 1.141 1.141Z"
            fill="#00FA82"
          />
          <path
            d="M10.196 17.846h.026c.295 0 .59-.117.81-.332.219-.214.336-.5.341-.806.005-.306-.117-.591-.331-.81a1.135 1.135 0 0 0-.845-.337h-.005c-.627.005-1.141.51-1.141 1.137v.061c.015.606.514 1.09 1.105 1.09Z"
            fill="#00FA82"
          />
          <path
            d="M16.74 11.424h.087c.305-.021.58-.164.784-.398.199-.234.296-.53.276-.835-.041-.57-.49-1.013-1.056-1.054a1.125 1.125 0 0 0-.835.276c-.234.199-.371.479-.396.785v.174c.026.306.163.581.397.785.209.179.474.276.744.276Z"
            fill="#00FA82"
          />
          <path
            d="M23.254 11.424h.087c.306-.021.581-.164.785-.398.199-.234.296-.53.276-.835-.041-.57-.49-1.013-1.056-1.054a1.127 1.127 0 0 0-.835.276c-.234.199-.371.479-.396.785v.174c.025.306.163.581.397.785.209.179.474.276.744.276Z"
            fill="#00FA82"
          />
          <path
            d="M10.232 22.068a1.133 1.133 0 0 0-.805.332c-.214.214-.337.5-.337.806s.118.596.337.81c.215.214.5.331.806.331s.591-.117.805-.336c.214-.219.332-.504.332-.805 0-.627-.515-1.141-1.141-1.141Z"
            fill="#00FA82"
          />
          <path
            d="M23.346 15.625c-.632-.041-1.182.428-1.228 1.054v.174c.025.305.163.58.397.785.209.179.474.276.744.276h.087c.306-.025.586-.163.785-.397.199-.234.296-.53.276-.835-.041-.57-.49-1.013-1.056-1.054Z"
            fill="#00FA82"
          />
          <path
            d="M10.242 28.566c-.637 0-1.151.515-1.151 1.152l.016.255h.031a1.122 1.122 0 0 0 1.115.885c.626 0 1.141-.515 1.141-1.142s-.51-1.146-1.141-1.146Z"
            fill="#00FA82"
          />
          <path
            d="M23.346 22.134a1.127 1.127 0 0 0-.835.276c-.234.199-.371.479-.396.785v.174c.025.306.163.581.397.785.209.179.474.276.744.276h.087c.306-.025.586-.163.785-.397.199-.234.296-.53.276-.835-.041-.57-.49-1.013-1.056-1.054Z"
            fill="#00FA82"
          />
          <path
            d="M16.746 15.554c-.632 0-1.146.515-1.146 1.146v.046c.01.611.51 1.1 1.126 1.1.637 0 1.166-.51 1.166-1.146s-.515-1.146-1.146-1.146Z"
            fill="#00FA82"
          />
          <path
            d="M16.766 22.078a1.133 1.133 0 0 0-.815.321c-.219.214-.341.494-.351.8v.082c.015.606.514 1.085 1.105 1.085h.031c.627.016 1.146-.499 1.156-1.126a1.126 1.126 0 0 0-.321-.815 1.142 1.142 0 0 0-.805-.337Z"
            fill="#00FA82"
          />
          <path
            d="M23.346 28.643a1.127 1.127 0 0 0-.835.276c-.234.199-.371.479-.396.785v.173c.046.601.55 1.059 1.141 1.059h.087c.306-.025.586-.163.785-.397.199-.234.296-.53.276-.835-.041-.57-.49-1.013-1.056-1.054Z"
            fill="white"
          />
          <path
            d="M16.761 28.582h-.016c-.627 0-1.136.505-1.146 1.126v.077c.005.296.132.576.346.78.209.199.479.306.759.306h.031c.627 0 1.141-.505 1.146-1.131 0-.305-.112-.595-.326-.814a1.132 1.132 0 0 0-.795-.344Z"
            fill="white"
          />
          <path
            d="M29.768 11.352a1.141 1.141 0 0 0 0-2.283c-.627 0-1.141.51-1.141 1.142 0 .626.514 1.136 1.141 1.141Z"
            fill="white"
          />
          <path
            d="M29.768 22.068a1.133 1.133 0 0 0-.805.332c-.214.214-.336.5-.336.806 0 .306.117.596.336.81.215.214.5.331.806.331s.591-.117.805-.336c.214-.219.332-.504.332-.805 0-.626-.514-1.141-1.141-1.141Z"
            fill="white"
          />
          <path
            d="M29.768 28.577c-.627 0-1.141.51-1.141 1.141 0 .631.514 1.141 1.141 1.141.626 0 1.141-.515 1.141-1.141s-.51-1.146-1.141-1.146Z"
            fill="white"
          />
          <path
            d="M29.738 17.846h.026c.306 0 .591-.117.81-.332.22-.214.337-.5.337-.806 0-.626-.505-1.146-1.136-1.146h-.005c-.627 0-1.137.509-1.142 1.136v.061c.016.606.515 1.091 1.11 1.091Z"
            fill="white"
          />
        </g>
      </svg>
    </Avatar>
  );
};
